import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import ImageAndContent from 'src/app/molecules/ImageAndContent/ImageAndContent';
import { IStaticContentfulImages } from 'src/types/contentful';

const MakingTheSwitchImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      featuredImage: contentfulAsset(contentful_id: { eq: "1x9tX7UIEIjKe5LEUXatrw" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1300)
      }
    }
  `);

  return (
    <Stack
      margin={['spacing-none', 'spacing-auto']}
      justify='center'
      align='center'
    >
      <ImageAndContent
        image={{
          imageProps: {
            image: images.featuredImage.gatsbyImageData,
            alt: 'Is it easy to move to Mighty?',
          },
          maxWidth: 650,
          radius: 'radius-2xl',
        }}
        contentPosition='left'
        content={
          <Stack
            padding={['spacing-none', 'spacing-4xl']}
            paddingMd='spacing-none'
            direction='column'
            gap='spacing-4xl'
          >
            <HeadingAndSupportingText
              maxWidth='width-2xl'
              gap='spacing-3xl'
              heading={{
                type: 'heading',
                text: 'Is it easy to move to Mighty?',
                size: 'lg',
                letterSpacing: -1,
                fontWeight: 'font-weight-semibold',
              }}
              subHeading={{
                text: 'Making the Switch',
                size: 'md',
                type: 'paragraph',
                color: 'text-brand-secondary',
                fontWeight: 'font-weight-semibold',
              }}
              subHeadingGap='spacing-lg'
              supportingText={{
                type: 'paragraph',
                size: 'xl',
                color: 'text-tertiary',
                children: (
                  <Stack
                    direction='column'
                    gap='spacing-lg'
                    as='span'
                  >
                    <Typography
                      as='span'
                      text='Yes. Our Scale and Growth plans include migration support.'
                    />
                    <Typography
                      as='span'
                      text='Migrated communities have 81-100% retention rates in their first year. When your members can finally find each other, they stick around.'
                    />
                  </Stack>
                ),
              }}
            />
            <Stack maxWidth='width-fit-content'>
              <Button
                variant='primary'
                size='xl'
                href='/migration'
              >
                Learn More
              </Button>
            </Stack>
          </Stack>
        }
      />
    </Stack>
  );
};

export default MakingTheSwitchImageAndContent;
